import React, { useEffect, useState, useRef } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, Form } from 'react-final-form';
import { useForm } from 'react-final-form';
import CustomSelect from '../../../components/form/CustomSelect';
import EmployedSelected from './employment/EmployedSelected';
import SelfEmployedSelected from './employment/SelfEmployedSelected';
import UnemployedRetiredSelected from './employment/UnemployedRetiredSelected';
import HousewifeSelected from './employment/HousewifeSelected';
import StudentSelected from './employment/StudentSelected';
import { useDict } from '../../../contexts/LanguageContext';
import HighNetWorthInvestor from './employment/HighNetWorthInvestor';
import { InvestorCategory, InvestorCategoryThresholds } from '../../../utils/constants';

const InvestorCategoryAutoSelect = () => {
    const form = useForm();
    const hasAutoSelected = useRef(false);

    useEffect(() => {
        if (hasAutoSelected.current) return;

        const subscription = form.subscribe(
            (state) => {
                if (state.values?.networth_id && state.values?.annual_income) {
                    const netWorthValue = parseInt(state.values.networth_id);
                    const annualIncomeValue = parseInt(state.values.annual_income);
                    const currentValue = state.values?.investor_category_id;

                    if (
                        netWorthValue >= InvestorCategoryThresholds.NET_WORTH_MIN_VALUE &&
                        annualIncomeValue >= InvestorCategoryThresholds.ANNUAL_INCOME_MIN_VALUE
                    ) {
                        if (currentValue === InvestorCategory.Retail && !hasAutoSelected.current) {
                            hasAutoSelected.current = true;
                            form.change('investor_category_id', InvestorCategory.HNWI);
                        }
                    } else if (currentValue === InvestorCategory.HNWI && hasAutoSelected.current) {
                        hasAutoSelected.current = false;
                        form.change('investor_category_id', InvestorCategory.Retail);
                    }
                }
            },
            { values: true }
        );

        return () => subscription();
    }, [form]);

    return null;
};

const DocumentsUpload = (props) => {
    const {
        onSubmit,
        previousPage,
        wealthDeclaration,
        submitted,
        employmentStatuses,
        jobCategories,
        annualIncomeRanges,
        netWorthRanges,
        source,
    } = props;

    const dict = useDict();

    const [selectedEmploymentStatusId, setSelectedEmploymentStatusId] =
        useState('');

    const calculateInvestorCategory = (netWorthId, annualIncomeId) => {
        if (!netWorthId || !annualIncomeId) return InvestorCategory.Retail;

        const netWorthValue = parseInt(netWorthId);
        const annualIncomeValue = parseInt(annualIncomeId);

        return (netWorthValue >= InvestorCategoryThresholds.NET_WORTH_MIN_VALUE && annualIncomeValue >= InvestorCategoryThresholds.ANNUAL_INCOME_MIN_VALUE)
            ? InvestorCategory.HNWI
            : InvestorCategory.Retail;
    };

    const handleOpen = () => {
        // window.open(
        //     'http://www.hasil.gov.my/bt_goindex.php?bt_kump=2&bt_skum=6&bt_posi=1&bt_unit=5&bt_sequ=1&bt_lgv=2',
        //     '_blank'
        // );
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        setSelectedEmploymentStatusId(wealthDeclaration?.employment_status_id);
    }, []);

    const validateStepWealth = (values) => {
        const errors = {};
        if (!values.employment_id) {
            errors.employment_id = dict.employmentEmpty;
        } else if (
            values.employment_id === 1 ||
            values.employment_id === 3
        ) {
            if (!values.company_name) {
                errors.company_name = dict.companyNameEmpty;
            }
            if (!values.job_category_id) {
                errors.job_category_id = dict.jobCategoryEmpty;
            }

            if (!values.annual_income) {
                errors.annual_income = dict.annualIncomeEmpty;
            }

            if (!values.networth_id) {
                errors.networth_id = dict.netWorthEmpty;
            }
        } else if (values.employment_id === 2) {
            if (!values.company_name) {
                errors.company_name = dict.companyNameEmpty;
            }
            if (!values.job_category_id) {
                errors.job_category_id = dict.jobCategoryEmpty;
            }
            if (!values.annual_income) {
                errors.annual_income = dict.annualIncomeEmpty;
            }
            if (!values.networth_id) {
                errors.networth_id = dict.netWorthEmpty;
            }
        } else if (values.employment_id === 4) {
            if (!values.source_of_wealth) {
                errors.source_of_wealth = dict.sourceOfWealthEmpty;
            }
            if (!values.networth_id) {
                errors.networth_id = dict.netWorthEmpty;
            }
            if (!values.spouseEmployed) {
                errors.spouseEmployed = dict.selectEmpty;
            } else if (values.spouseEmployed === '1') {
                if (!values.company_name) {
                    errors.company_name = dict.companyNameEmpty;
                }
                if (!values.job_category_id) {
                    errors.job_category_id = dict.jobCategoryEmpty;
                }
            }
        } else if (values.employment_id === 5) {
            if (!values.source_of_wealth) {
                errors.source_of_wealth = dict.sourceOfWealthEmpty;
            }
            if (!values.networth_id) {
                errors.networth_id = dict.netWorthEmpty;
            }
            if (!values.employedPrevious) {
                errors.employedPrevious = dict.selectEmpty;
            } else if (values.employedPrevious === '1') {
                if (!values.company_name) {
                    errors.company_name =
                        dict.companyNameEmpty;
                }
                if (!values.job_category_id) {
                    errors.job_category_id = dict.jobCategoryEmpty;
                }
            }
        }
        if (!values.investor_category_id) {
            errors.investor_category_id = dict.selectEmpty;
        }

        return errors;
    };

    return (
        <Form
            initialValues={{
                submitted,
                employment_id: wealthDeclaration?.employment_status_id || '',
                check_tax_declare: wealthDeclaration?.is_thailand_tax === 1,
                pep_declare: wealthDeclaration?.is_pep === 1,
                company_name:
                    wealthDeclaration?.company_name ||
                    wealthDeclaration?.previous_company_name ||
                    wealthDeclaration?.partner_name ||
                    '',
                job_category_id:
                    wealthDeclaration?.job_category_id ||
                    wealthDeclaration?.previous_job_category_id ||
                    wealthDeclaration?.partner_job_category_id ||
                    '',
                annual_income: wealthDeclaration?.annual_income_range_id || '',
                networth_id: wealthDeclaration?.net_worth_range_id || '',
                source_of_wealth: wealthDeclaration?.source_of_wealth_id || '',
                spouseEmployed: wealthDeclaration?.is_partner_work || '0',
                employedPrevious: wealthDeclaration?.is_work_previously || '0',
                investor_category_id: calculateInvestorCategory(
                    wealthDeclaration?.net_worth_range_id,
                    wealthDeclaration?.annual_income_range_id
                ),
            }}
            validate={validateStepWealth}
            onSubmit={onSubmit}
        >
            {({ handleSubmit, values }) => (
                <form className="form wizard__form_2" onSubmit={handleSubmit}>
                    <InvestorCategoryAutoSelect netWorthRanges={netWorthRanges} annualIncomeRanges={annualIncomeRanges} />
                    <div
                        className="form__form-group"
                        style={{
                            borderBottom: 'dashed 1px #DDDDDD',
                        }}
                    >
                        <div
                            className="card__title"
                            style={{ marginBottom: '5px' }}
                        >
                            <h4
                                className="bold-text"
                                style={{ fontSize: '14px' }}
                                data-cy="wealthDeclaration__title"
                            >
                                {dict.wealthDeclarationSource}
                            </h4>
                            <h5 className="subhead">
                                {dict.wealthDeclarationSourceText}
                            </h5>
                        </div>
                    </div>
                    <div
                        className="form__form-group"
                        style={{ marginTop: '-10px' }}
                    >
                        <span className="form__form-group-label">
                            {dict.employmentStatus}:
                            <span
                                style={{ color: '#FF3333', fontWeight: 'bold' }}
                            >
                                *
                            </span>
                        </span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-input-wrap">
                                <Field name="employment_id">
                                    {({ input, meta }) => (
                                        <CustomSelect
                                            input={input}
                                            meta={meta}
                                            submitted={submitted}
                                            placeholder={
                                                dict.selectEmploymentStatus
                                            }
                                            options={employmentStatuses}
                                            onChange={(value) => {
                                                input.onChange(value.value);
                                                setSelectedEmploymentStatusId(
                                                    value ? value.value : null
                                                );
                                            }}
                                            data-cy="wealthDeclaration__employmentId"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                    </div>
                    {/* 1. EMPLOYED SELECTED */}
                    {selectedEmploymentStatusId === 1 && (
                        <EmployedSelected
                            submitted={submitted}
                            jobCategory={jobCategories}
                            annualIncome={annualIncomeRanges}
                            netWorth={netWorthRanges}
                        />
                    )}
                    {/* 2. EMPLOYED SELF SELECTED */}
                    {selectedEmploymentStatusId === 2 && (
                        <SelfEmployedSelected
                            submitted={submitted}
                            jobCategory={jobCategories}
                            annualIncome={annualIncomeRanges}
                            netWorth={netWorthRanges}
                        />
                    )}
                    {/* 3. UNEMPLOYED/ RETIRED SELECTED */}
                    {selectedEmploymentStatusId === 3 && (
                        <UnemployedRetiredSelected
                            submitted={submitted}
                            jobCategory={jobCategories}
                            annualIncome={annualIncomeRanges}
                            netWorth={netWorthRanges}
                        />
                    )}
                    {/* 4. HOUSEWIFE SELECTED */}
                    {selectedEmploymentStatusId === 4 && (
                        <HousewifeSelected
                            submitted={submitted}
                            spouseEmployed={values.spouseEmployed === '1'}
                            sourceOfWealth={source}
                            jobCategory={jobCategories}
                            netWorth={netWorthRanges}
                            annualIncome={annualIncomeRanges}
                        />
                    )}
                    {/* 5. STUDENT SELECTED */}
                    {selectedEmploymentStatusId === 5 && (
                        <StudentSelected
                            submitted={submitted}
                            employedStudent={values.employedPrevious === '1'}
                            sourceOfWealth={source}
                            jobCategory={jobCategories}
                            netWorth={netWorthRanges}
                            annualIncome={annualIncomeRanges}
                        />
                    )}
                    {/* HNWI */}
                    {selectedEmploymentStatusId && (
                        <HighNetWorthInvestor submitted={submitted} />
                    )}
                    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                        <Button
                            color="primary"
                            type="button"
                            className="previous btn-outline-primary btn_uni rounded"
                            onClick={previousPage}
                            data-cy="wealthDeclaration__backBtn"
                        >
                            {dict.back}
                        </Button>
                        <Button
                            color="primary"
                            type="submit"
                            className="next btn btn-primary btn_uni rounded"
                            data-cy="wealthDeclaration__nextBtn"
                        >
                            {dict.next}
                        </Button>
                    </ButtonToolbar>
                </form>
            )}
        </Form>
    );
};

export default DocumentsUpload;
